import styled, { css } from "styled-components";

import { IStyledAttributes, RideDelayStatusEnum } from "@ryde/shared";

import { RideStatusDelayToColor } from "../../../utils";

export const DragRideRowIconReplacement = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "drag-ride-row-icon-replacement",
})<{ $color?: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  ${({ $color }) =>
    $color &&
    css`
      background-color: ${$color};
    `}
`;

export const LiveMapGroupingStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "live-map-grouping-cell",
})<{ $delayStatus: RideDelayStatusEnum }>`
  ${({ $delayStatus }) => css`
    color: ${RideStatusDelayToColor[$delayStatus]};
  `}
`;
